module.exports = __webpack_public_path__ + "img/analysis-payout.85ce2d58.svg";